<template>
    <button class="save-button" @click.stop="$emit('click', $event)">
        <heart-unfilled
                v-show="!score || score == 0"
                :class="classes">
        </heart-unfilled>
        <img v-show="score == 1"
             :class="classes"
             :src="imageUrl('like_fill.svg')"/>
        <heart-animated v-show="animating" :class="classes"
                        class="icon-heart-animating"></heart-animated>
     </button>
</template>

<script>
    import HeartAnimated from "../common/heart-animated.vue";
    import HeartUnfilled from "../common/heart-unfilled.vue";
    import Mixins from "../../mixins/mixins";

    export default {
        props: {
            saveProduct: Function,
            score: Number|String,
            animating: Boolean,
            classes: String|Array|Object,
        },
        components: {
            HeartAnimated,
            HeartUnfilled,
        },
        mixins: [Mixins],
    };
</script>


<style lang="scss" scoped>
    .save-button {
        width: 20px;
        position: relative;
    }
    .icon-heart-animating {
        left:0;
        top:2px;
    }

    .loading {
        animation: lds-heart 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    @keyframes lds-heart {
        0% {
            transform: scale(0.95);
        }
        5% {
            transform: scale(1.3);
        }
        39% {
            transform: scale(0.85);
        }
        45% {
            transform: scale(1.2);
        }
        60% {
            transform: scale(0.95);
        }
        100% {
            transform: scale(0.9);
        }
    }
</style>